import { render, staticRenderFns } from "./touchDetail.vue?vue&type=template&id=60856c4e&scoped=true&"
import script from "./touchDetail.vue?vue&type=script&lang=js&"
export * from "./touchDetail.vue?vue&type=script&lang=js&"
import style0 from "./touchDetail.vue?vue&type=style&index=0&id=60856c4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60856c4e",
  null
  
)

export default component.exports